<script>
export default {
    name: "Footer",
    methods: {
        openLink(link) {
            if (link) {
                window.open(link, '_blank')
            } else {
                console.error('Нет ссылки')
            }
        }
    },
}
</script>

<template>
    <div class="ftr-content">
    <section class="footer">
            <div class="ftr-left-right-container">
                <div class="ftr-left-content">
                    <div class="footer-txt-cotaniner">
                        <div class="ftr-buttons">
                            <a class="ftr-button" href="/user-agreement.pdf">{{__('Пользовательское соглашение')}}</a>
                            <div class="ftr-button" @click="$router.push('/privacy-policy')">{{__('Политика конфиденциальности')}}</div>
                        </div>
                        <div class="ftr-social-links">
                            <div @click="openLink('https://www.youtube.com/@cloudmodsofficial')" class="ftr-social-link">
                                <svg class="socialIcon" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3505 1.01374C22.3825 1.29396 23.199 2.11905 23.4763 3.16209C23.9846 5.06136 24 9 24 9C24 9 24 12.9542 23.4917 14.8379C23.2144 15.881 22.3979 16.706 21.3659 16.9863C19.5019 17.5 12 17.5 12 17.5C12 17.5 4.49807 17.5 2.63415 16.9863C1.60205 16.706 0.785623 15.881 0.508344 14.8379C0 12.9386 0 9 0 9C0 9 0 5.06136 0.49294 3.17766C0.770218 2.13462 1.58665 1.30952 2.61874 1.0293C4.48267 0.515568 11.9846 0.5 11.9846 0.5C11.9846 0.5 19.4865 0.5 21.3505 1.01374ZM15.5 9L9.5 12.5V5.5L15.5 9Z" fill="#FF0033"/>
                                </svg>
                                @cloud-mods
                            </div>
                            <div @click="openLink('https://vk.com/cloudmodscis')" class="ftr-social-link">
                                <svg class="socialIcon" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.66C0 4.81334 0 2.89001 1.195 1.695C2.39001 0.5 4.31333 0.5 8.15995 0.5H8.16H8.84H8.84005C12.6867 0.5 14.61 0.5 15.805 1.695C17 2.89001 17 4.81334 17 8.66V9.34C17 13.1867 17 15.11 15.805 16.305C14.61 17.5 12.6867 17.5 8.84 17.5H8.16C4.31334 17.5 2.39001 17.5 1.195 16.305C0 15.11 0 13.1867 0 9.34V8.66ZM9.17664 13.0762C5.30206 13.0762 3.09207 10.42 3 6H4.94082C5.00457 9.24416 6.43538 10.6183 7.5687 10.9016V6H9.39627V8.79789C10.5154 8.67748 11.6911 7.4025 12.0878 6H13.9153C13.6108 7.72832 12.3358 9.00332 11.4291 9.52748C12.3358 9.95248 13.7879 11.0646 14.3404 13.0762H12.3287C11.8966 11.7304 10.82 10.6891 9.39627 10.5475V13.0762H9.17664Z" fill="#0077FF"/>
                                </svg>
                                @cloudmods
                            </div>
                            <div @click="openLink('https://t.me/cloudmodsss')" class="ftr-social-link">
                                <svg class="socialIcon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3427 0.0957787C14.5394 0.0109721 14.7547 -0.0182776 14.9662 0.0110746C15.1777 0.0404268 15.3777 0.127308 15.5453 0.262674C15.7129 0.39804 15.842 0.576943 15.9192 0.780762C15.9964 0.984581 16.0188 1.20587 15.9842 1.42158L14.1787 12.6387C14.0035 13.7207 12.8445 14.3412 11.8757 13.8023C11.0653 13.3514 9.86161 12.6567 8.77895 11.9318C8.23763 11.5689 6.57942 10.407 6.78321 9.58024C6.95835 8.87331 9.74458 6.21681 11.3367 4.63743C11.9616 4.01693 11.6766 3.65898 10.9387 4.22974C9.10534 5.64687 6.16387 7.80191 5.19107 8.40855C4.33291 8.94343 3.88552 9.03476 3.35056 8.94343C2.37458 8.7771 1.46945 8.51944 0.730701 8.20552C-0.267568 7.78152 -0.219008 6.37581 0.729905 5.96649L14.3427 0.0957787Z" fill="#24A1DE"/>
                                </svg>
                                @cloudmods
                            </div>
                            <div @click="openLink('https://discord.gg/MCSkQab2EB')" class="ftr-social-link">
                                <svg class="socialIcon" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.75229 1.17248C3.93491 0.616848 5.18338 0.222666 6.46582 0C6.64131 0.321942 6.8001 0.653178 6.94152 0.99232C8.30757 0.781074 9.69675 0.781074 11.0628 0.99232C11.2043 0.653213 11.3631 0.321981 11.5385 0C12.8218 0.224546 14.071 0.619664 15.2549 1.17538C17.605 4.74367 18.2421 8.22333 17.9236 11.6536C16.5472 12.6971 15.0068 13.4908 13.3691 14C13.0003 13.491 12.674 12.9511 12.3936 12.3858C12.9262 12.1817 13.4402 11.9299 13.9297 11.6332C13.8009 11.5374 13.6749 11.4386 13.5531 11.3427C12.1287 12.0301 10.5741 12.3865 9.00003 12.3865C7.42599 12.3865 5.87134 12.0301 4.44695 11.3427C4.32378 11.4458 4.19778 11.5446 4.07036 11.6332C4.56083 11.9304 5.07578 12.1827 5.60929 12.3873C5.32924 12.9523 5.00291 13.4918 4.63383 14C2.99473 13.4928 1.45307 12.6996 0.0765012 11.655C-0.297259 7.67704 0.715009 4.22935 2.75229 1.17248ZM11.9901 9.544C12.8778 9.544 13.6112 8.71731 13.6112 7.70029C13.6112 6.68327 12.9033 5.84931 11.9929 5.84931C11.0826 5.84931 10.3549 6.68327 10.3705 7.70029C10.3861 8.71731 11.0854 9.544 11.9901 9.544ZM6.00995 9.544C6.89904 9.544 7.62958 8.71731 7.62958 7.70029C7.62958 6.68327 6.9217 5.84931 6.00995 5.84931C5.0982 5.84931 4.37616 6.68327 4.39174 7.70029C4.40731 8.71731 5.10528 9.544 6.00995 9.544Z" fill="#5865F2"/>
                                </svg>
                                @cmods
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ftr-right-content">
                    <div class="ftr-payments-container-up">
                        <div class="ftr-payment">
                            <svg class="paymentIcon" width="38" height="16" viewBox="0 0 38 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 3.48022L1.93159 6.94121V9.05231L0.00225963 12.5065L0 3.48022Z" fill="#5B57A2"/>
                                <path d="M7.4165 5.68192L9.22647 4.56987L12.9307 4.56641L7.4165 7.95264V5.68192Z" fill="#D90751"/>
                                <path d="M7.40622 3.45992L7.41645 8.04215L5.48035 6.84962V0L7.40622 3.45992Z" fill="#FAB718"/>
                                <path d="M12.9306 4.56637L9.22628 4.56984L7.40622 3.45992L5.48035 0L12.9306 4.56637Z" fill="#ED6F26"/>
                                <path d="M7.41645 12.5258V10.3027L5.48035 9.13281L5.48141 15.9892L7.41645 12.5258Z" fill="#63B22F"/>
                                <path d="M9.22196 11.4238L1.93145 6.94121L0 3.48022L12.9228 11.4192L9.22196 11.4238Z" fill="#1487C9"/>
                                <path d="M5.48157 15.9893L7.41634 12.5259L9.22179 11.424L12.9227 11.4194L5.48157 15.9893Z" fill="#017F36"/>
                                <path d="M0.00231934 12.5066L5.49628 9.13286L3.64923 7.99683L1.93165 9.05238L0.00231934 12.5066Z" fill="#984995"/>
                                <path d="M37.9143 5.34055V12.1462H35.4901V7.37218H33.1558V12.1462H30.7316V5.34009H37.9143V5.34055Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.7525 12.3895C27.9229 12.3895 29.5345 11.0556 29.5345 9.03375C29.5345 7.07658 28.3455 5.80583 26.3584 5.80583C25.4413 5.80583 24.6846 6.12943 24.1146 6.68779C24.2507 5.53372 25.2242 4.69119 26.2961 4.69119C26.5435 4.69119 28.4059 4.68725 28.4059 4.68725L29.4588 2.66675C29.4588 2.66675 27.1209 2.7201 26.0339 2.7201C23.5504 2.76371 21.8729 5.02662 21.8729 7.77483C21.8729 10.977 23.509 12.3897 25.7528 12.3897L25.7525 12.3895ZM25.766 7.59528C26.5717 7.59528 27.1304 8.12603 27.1304 9.03352C27.1304 9.85007 26.634 10.5233 25.766 10.5251C24.9357 10.5251 24.377 9.90157 24.377 9.04744C24.377 8.13972 24.9357 7.59528 25.766 7.59528Z" fill="white"/>
                                <path d="M19.8997 9.86786C19.8997 9.86786 19.3272 10.1987 18.4719 10.2613C17.4891 10.2905 16.6132 9.66813 16.6132 8.56231C16.6132 7.48363 17.3861 6.86541 18.4474 6.86541C19.0981 6.86541 19.959 7.31753 19.959 7.31753C19.959 7.31753 20.5889 6.15882 20.9152 5.57935C20.3177 5.12537 19.5218 4.87646 18.5962 4.87646C16.2601 4.87646 14.4507 6.40332 14.4507 8.54862C14.4507 10.7213 16.1513 12.2127 18.5962 12.1674C19.2795 12.1419 20.2223 11.9016 20.7969 11.5316L19.8997 9.86786Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="ftr-payment">
                            <svg class="paymentIcon" width="36" height="10" viewBox="0 0 36 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_482_433)">
                                    <path d="M0.138672 0.523705H3.47992C3.78367 0.523705 4.69492 0.428467 5.09992 1.7618C5.40367 2.61894 5.80867 3.95228 6.41617 5.95228H6.61867C7.22617 3.85704 7.73242 2.42847 7.93492 1.7618C8.33992 0.428467 9.35242 0.523705 9.75742 0.523705H12.8962V9.66656H9.65617V4.23799H9.45367L7.73242 9.66656H5.30242L3.58117 4.23799H3.27742V9.66656H0.138672M14.2124 0.523705H17.4524V5.95228H17.7562L19.8824 1.47609C20.2874 0.618943 21.1987 0.523705 21.1987 0.523705H24.2362V9.66656H20.9962V4.23799H20.7937L18.6674 8.71418C18.2624 9.57132 17.2499 9.66656 17.2499 9.66656H14.2124M28.5899 6.90466V9.66656H25.5524V4.90466H35.4749C35.0699 6.04751 33.6524 6.90466 32.0324 6.90466" fill="white"/>
                                    <path d="M35.6776 4.33345C36.0826 2.61916 34.8676 0.523926 32.2351 0.523926H25.3501C25.5526 2.52393 27.3751 4.33345 29.2988 4.33345" fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_482_433">
                                        <rect width="36" height="10" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="ftr-payment third-logo">
                          <a href="https://freekassa.net" target="_blank" rel="noopener noreferrer">
                          <img src="https://cdn.freekassa.net/banners/small-dark-1.png" title="Прием платежей на сайте">
                          </a>
                        </div>
                    </div>
                    <div class="ftr-payments-container-down">
                        <div class="ftr-payment">
                            <svg class="paymentIcon" width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5077 1.71143H9.47168V14.2888H16.5077V1.71143Z" fill="#FF5A00"/>
                                <path d="M9.93993 8.00001C9.93993 5.44466 11.1473 3.1767 13 1.71133C11.6365 0.644661 9.91651 0 8.04041 0C3.59607 0 0 3.578 0 8.00001C0 12.422 3.59607 16 8.04041 16C9.91651 16 11.6365 15.3554 13 14.2887C11.1447 12.844 9.93993 10.5553 9.93993 8.00001Z" fill="#EB001B"/>
                                <path d="M26.0002 8.00001C26.0002 12.422 22.4041 16 17.9598 16C16.0837 16 14.3637 15.3554 13.0002 14.2887C14.8763 12.8207 16.0603 10.5553 16.0603 8.00001C16.0603 5.44466 14.8529 3.1767 13.0002 1.71133C14.3611 0.644661 16.0811 0 17.9572 0C22.4041 0 26.0002 3.6013 26.0002 8.00001Z" fill="#F79E1B"/>
                            </svg>
                        </div>
                        <div class="ftr-payment">
                            <svg class="paymentIcon" width="39" height="12" viewBox="0 0 39 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.8288 0.18136L9.71434 11.8232H6.37354L3.84954 2.5372C3.82183 2.31976 3.73811 2.11232 3.60601 1.93336C3.47382 1.7544 3.29735 1.60952 3.09234 1.5116C2.10911 1.06472 1.06979 0.740479 0 0.546799L0.0636234 0.18504H5.42748C5.78318 0.17704 6.12926 0.29624 6.39781 0.519279C6.66637 0.742399 6.83807 1.05328 6.87926 1.39104L8.20287 8.14079L11.4841 0.2412H14.8288V0.18136ZM27.8907 8.02023C27.8907 4.94455 23.4739 4.76407 23.4739 3.43751C23.4739 3.01496 23.916 2.59336 24.7994 2.47272C25.8635 2.36184 26.9384 2.55064 27.8917 3.01584L28.4601 0.543119C27.5114 0.20048 26.508 0.0168 25.494 0C22.4016 0 20.1956 1.56504 20.1956 3.85911C20.1956 5.54751 21.7735 6.45247 22.9719 6.99471C24.1703 7.53695 24.6096 7.89967 24.6096 8.44183C24.6096 9.22622 23.6626 9.58799 22.7167 9.58799C21.5988 9.59495 20.4954 9.34687 19.4981 8.86439L18.9297 11.3969C20.0377 11.7979 21.213 12.0022 22.3978 12C25.6789 12 27.8243 10.4349 27.8888 8.02023M36.0936 11.8232H39L36.4761 0.18504H33.7595C33.4747 0.17952 33.1951 0.25744 32.9581 0.408399C32.7211 0.559279 32.5381 0.775999 32.4338 1.0292L27.7019 11.8232H30.9831L31.6141 10.0741H35.6524L36.0936 11.8232ZM32.5601 7.72287L34.1978 3.38135L35.1447 7.72287H32.5601ZM19.3093 0.18136L16.7218 11.8232H13.5677L16.1553 0.18504H19.3093V0.18136Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="ftr-payment">
                            <svg class="paymentIcon" width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2128 12.8146V9.55276H26.9129C30.1409 9.55276 31.8716 8.3273 31.8716 5.89094C31.8716 3.5273 30.3936 2.34548 26.9129 2.34548H23.2446V12.8128L25.2128 12.8146ZM25.2128 4.06548V7.83275L27.0622 7.83094C28.8887 7.83094 29.8326 7.26366 29.8326 5.84366C29.8326 4.55639 29.0132 4.06548 27.0948 4.06548H25.2128Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M32.9093 5.86003C33.4282 5.49094 34.374 5.1873 35.7295 5.1873C38.027 5.1873 39.1623 5.93457 39.1623 7.87821V12.8128H37.4296V11.4673C37.0525 12.3328 36.0933 12.9328 34.8316 12.9328C33.2425 12.9328 32.2986 12.0782 32.2986 10.6146C32.2986 8.90912 33.6043 8.43094 35.54 8.43094H37.3205V8.10366C37.3205 7.04184 36.7844 6.71094 35.7295 6.71094C34.2802 6.71094 33.4473 7.25094 32.9132 8.04184L32.9093 5.86003ZM37.3167 9.56912V10.1728C37.2401 10.6891 36.6562 11.3618 35.4136 11.3618C34.5923 11.3618 34.1519 11.0018 34.1519 10.4346C34.1519 9.76366 34.6727 9.56912 35.7601 9.56912H37.3167Z" fill="white"/>
                                <path d="M42.128 5.33639H40.0737L43.3859 12.8509C43.0872 13.8582 42.6622 14.2164 42.0974 14.2164C41.7434 14.2105 41.4051 14.0765 41.1516 13.8418V15.4746C41.3832 15.6673 41.9212 15.8018 42.4114 15.8018C43.451 15.8018 44.1575 15.3982 44.8524 13.6055L48 5.33639H46.0471L44.2857 10.4637L42.128 5.33639Z" fill="white"/>
                                <path d="M14.9009 7.83275V7.99639C14.9034 9.37203 14.4207 10.7088 13.5297 11.7935C12.6388 12.8782 11.391 13.6483 9.98535 13.9808C8.57974 14.3134 7.09734 14.1893 5.77467 13.6283C4.45199 13.0674 3.36527 12.1019 2.68788 10.8859C2.01049 9.66998 1.78146 8.27358 2.03735 6.91957C2.29323 5.56556 3.01928 4.33194 4.09966 3.41556C5.18003 2.49917 6.55247 1.95281 7.998 1.86365C9.44353 1.7745 10.8789 2.14768 12.075 2.92367L13.7196 1.77821C12.1829 0.598689 10.2585 -0.0303342 8.2829 0.00112533C6.30729 0.0325848 4.40619 0.722527 2.91201 1.95031C1.41782 3.17809 0.425634 4.86559 0.108933 6.71773C-0.207769 8.56988 0.171167 10.4688 1.17949 12.0825C2.1878 13.6962 3.76134 14.9219 5.62495 15.5454C7.48856 16.1689 9.52366 16.1505 11.3744 15.4933C13.2252 14.8362 14.7738 13.5822 15.7495 11.9505C16.7252 10.3188 17.0659 8.41337 16.7121 6.5673L14.9009 7.83275Z" fill="white"/>
                                <path d="M5.2208 8.16366V5.8673L8.42579 7.77639L15.0885 3.12003C15.4906 3.61094 15.8294 4.14367 16.0994 4.70912L8.42579 10.0728L5.2208 8.16366Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="ftr-payment">
                           <a href="https://aaio.so/" target="_blank">
	<img src="https://aaio.so/assets/svg/banners/mini/dark-1.svg"
	     title="Aaio - Сервис по приему онлайн платежей"
	     class="paymentIcon"
	     style="display:block; margin:0 auto;">
</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ftr-description">
                {{__('Cloud Mods © 2025. Все права защищены. Прочие бренды и/или названия продуктов являются товарными знаками соответствующих владельцев. На наших платформах могут содержаться ссылки на сторонние сайты и/или ресурсы. Эти ссылки предоставлены исключительно для вашего удобства. Cloud Mods не контролирует содержание таких сайтов и/или ресурсов и не несёт ответственности за них, а также за причинённые убытки и/или ущерб, который может возникнуть в результате их использования вами.')}}
            </div>
    </section>
    </div>
</template>

<style>
.ftr-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.ftr-content .third-logo {
    filter: grayscale(100%);  /* Делаем изображение серым */
    transition: filter 0.3s ease;  /* Плавное изменение при наведении */
}

/* Эффект при наведении на третий логотип */
.ftr-content .third-logo:hover {
    filter: grayscale(0%);  /* Убираем серый цвет, возвращаем оригинальный */
}

.footer {
    user-select: none;

    display: flex;
    flex-direction: column;

    position: relative;

    background-repeat: no-repeat;
    background-position: center;
}

.ftr-left-content {
    display: flex;
    flex-direction: column;
}

.ftr-buttons {
    display: flex;
    flex-direction: column;
    color: rgba(255, 255, 255, 0.60);
    font-weight: 500;
}

.ftr-button {
    transition: 0.25s ease;
}

.ftr-button:hover {
    cursor: pointer;
    color: var(--text-primary);
}

.ftr-description {
    color: rgba(255, 255, 255, 0.20);
    font-weight: 500;
}

.ftr-payments-container-up, .ftr-payments-container-down {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
}

.ftr-payment {
    display: inline-flex;
    align-items: center;

    border: 1px solid #202020;
    transition: 0.25s ease;
}

.ftr-payment:hover .paymentIcon  {
    filter: none !important;
}

.ftr-payment:hover {
    background: #080808;
}

.paymentIcon {
    transition: 0.25s ease;
    filter: grayscale(100%) contrast(30%);
}

.ftr-social-links {
    display: flex;
    flex-direction: row;
}

.ftr-social-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #4F4F4F;
    transition: 0.25s ease;
}

.footer-txt-cotaniner {
    display: flex;
    flex-direction: column;
}

.ftr-social-link:hover  {
    cursor: pointer;
    color: #fff;
}

.socialIcon {
    transition: 0.25s ease;
    filter: grayscale(100%) contrast(0%);
}

.ftr-social-link:hover .socialIcon  {
    filter: none !important;
}

@media (min-width: 320px) {
    .footer {
        width: 100vw;
        padding: 5vw 5vw 10vw 5.75vw;
        gap: 5vw;
    }

    .ftr-description {
        width: 100%;
        line-height: 137%;
        font-size: 3.125vw;
    }

    .ftr-buttons {
        gap: 1.25vw;
        font-size: 3.75vw;
    }

    .ftr-payments-container-up, .ftr-payments-container-down {
        display: flex;
        justify-content: flex-start;
        gap: 3.125vw;
    }

    .ftr-payments-container-down {
        margin-top: 3.125vw;
    }

    .ftr-left-content {
        gap: 7.5vw;
    }

    .ftr-payment {
        border-radius: 2.5vw;
        padding: 0px 3.75vw;
        height: 10.625vw;
    }

    .ftr-right-content {
        right: 0px;
    }

    .ftr-social-links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4.375vw;
    }

    .ftr-social-link {
        font-size: 4.0625vw;
        gap: 1.875vw;
    }

    .footer-txt-cotaniner {
        gap: 5.3125vw;
    }

    .ftr-left-right-container {
        display: flex;
        flex-direction: column;
        gap: 6.875vw;
    }
}

@media (min-width: 464px) {
    .ftr-left-right-container {
        gap: 22px;
    }

    .footer {
        width: 464px;
        padding: 24px 0px;
        gap: 22px;
    }

    .ftr-description {
        width: 464px;
        line-height: 137%;
        font-size: 12px;
    }

    .ftr-buttons {
        gap: 10px;
        font-size: 14px;
    }

    .ftr-payments-container-up, .ftr-payments-container-down {
        width: 421px;
        gap: 10px;
    }

    .ftr-payments-container-down {
        margin-top: 10px;
    }

    .ftr-left-content {
        gap: 24px;
    }

    .ftr-payment {
        border-radius: 8px;
        padding: 0px 12px;
        height: 34px;
    }

    .ftr-right-content {
        right: 0px;
    }

    .ftr-social-links {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 14px;
    }

    .ftr-social-link {
        font-size: 13px;
        gap: 6px;
    }

    .footer-txt-cotaniner {
        gap: 17px;
    }
}

@media (min-width: 744px) {
    .footer {
        width: 744px;
        padding: 24px 0px;
        gap: 22px;
    }

    .ftr-description {
        width: 744px;
        line-height: 137%;
        font-size: 12px;
    }

    .ftr-buttons {
        gap: 10px;
        font-size: 14px;
    }

    .ftr-payments-container-up, .ftr-payments-container-down {
        display: flex;
        justify-content: flex-end;
        width: 421px;
        gap: 10px;
    }

    .ftr-payments-container-down {
        margin-top: 10px;
    }

    .ftr-left-content {
        gap: 24px;
    }

    .ftr-payment {
        border-radius: 8px;
        padding: 0px 12px;
        height: 34px;
    }

    .ftr-right-content {
        display: none;
        right: 0px;
    }

    .ftr-social-links {
        gap: 14px;
    }

    .ftr-social-link {
        font-size: 13px;
        gap: 6px;
    }

    .footer-txt-cotaniner {
        gap: 17px;
    }

    .ftr-left-right-container {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }
}

@media (min-width: 984px) {
    .footer {
        width: 984px;
        padding: 24px 0px;
        gap: 22px;
    }

    .ftr-description {
        width: 984px;
        line-height: 137%;
        font-size: 12px;
    }

    .ftr-buttons {
        gap: 10px;
        font-size: 16px;
    }

    .ftr-payments-container-up, .ftr-payments-container-down {
        width: 421px;
        gap: 10px;
    }

    .ftr-payments-container-down {
        margin-top: 10px;
    }

    .ftr-left-content {
        gap: 24px;
    }

    .ftr-payment {
        border-radius: 8px;
        padding: 0px 24px;
        height: 40px;
    }

    .ftr-right-content {
        display: block;
    }

    .ftr-social-links {
        gap: 14px;
    }

    .ftr-social-link {
        font-size: 14px;
        gap: 6px;
    }

    .footer-txt-cotaniner {
        gap: 17px;
    }
}

@media (min-width: 1248px) {
    .footer {
        width: 1248px;
        padding: 24px 0px;
        gap: 22px;
    }

    .ftr-buttons {
        gap: 10px;
        font-size: 16px;
    }

    .ftr-description {
        width: 1248px;
        line-height: 137%;
        font-size: 12px;
    }

    .ftr-payments-container-up, .ftr-payments-container-down {
        width: 421px;
        gap: 10px;
    }

    .ftr-payments-container-down {
        margin-top: 10px;
    }

    .ftr-left-content {
        gap: 24px;
    }

    .ftr-payment {
        border-radius: 8px;
        padding: 0px 24px;
        height: 40px;
    }

    .ftr-right-content {
        position: absolute;
        right: 0px;
    }

    .ftr-social-links {
        gap: 14px;
    }

    .ftr-social-link {
        font-size: 14px;
        gap: 6px;
    }

    .footer-txt-cotaniner {
        gap: 17px;
    }
}
</style>